import {Injectable, OnDestroy} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {UserService} from '../services/user/user.service';
import {DataService} from '../services/data.service';
import {AlertService} from '../services/alert/alert.service';
import {LoadingService} from '../services/loading/loading.service';
import {Observable} from 'rxjs';
import {User} from '../services/user/user';
import {ISubscription} from 'rxjs-compat/Subscription';
import AppConstants from '../shared/common-components/AppConstants';

@Injectable()
export class RouteGuard  implements OnDestroy {

    currentUrl: any;
    private strloader;
    currentUser: User;
    private user_subscription: ISubscription;


    constructor(private router: Router, private userService: UserService, private dataService: DataService, private alertService: AlertService, private loader: LoadingService) {
        router.events.subscribe((val) => {
            this.currentUrl = location.pathname;
        });
        this.strloader = this.loader;

        // this method is used to get the user details, instead of calling to server every time, by using behavioural subject
        this.user_subscription =  this.userService.getCurrentUserObservable().subscribe(currentUser => {
            this.currentUser = currentUser;
        }, (error) => {
            console.log(error);
        });

    }

    /**
     *  If a guards return true, navigation will continue. If any guard returns false, navigation will be cancelled
     * @param: route
     * @param: state
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
        const allowedRoles = route.data['roles'] as Array<string>;
        const allowedPermission = route.data['permission'];
        if (!this.isLoggedIn()) {
            this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        }
        if (this.currentUser) {
            const userRoles = Array.from(this.currentUser.roles, x => x.role);
            if (userRoles && userRoles.length > 0 && this.currentUser.userSessionEntity !== null) {
                // check if any of the user roles match the allowed roles
                const found = userRoles.some(role => allowedRoles.indexOf(role) >= 0) && (this.currentUser.userSessionEntity.jSessionId);
                let permission;
                if (AppConstants.isNotNullCondition(allowedPermission)) {
                    permission = this.checkUserBusinessType(allowedPermission) || this.checkUserBusinessType('HHG & FRT');
                } else {
                    permission = true;
                }
                if (found && permission) {
                    return true;
                } else {
                    // redirecting user to 404 page if user is not allowed to access the page
                    this.router.navigate(['/404'], { queryParams: { returnUrl: state.url }});
                    return false;
                }
            } else {
                this.router.navigate(['/404'], { queryParams: { returnUrl: state.url }});
                return false;
            }
        } else {
            this.router.navigate(['/404'], { queryParams: { returnUrl: state.url }});
            return false;
        }
    }

    /**
     * checking if user is logged in
     */
    isLoggedIn() {
        return this.currentUser !== null && this.currentUser !== undefined  && this.currentUser.id !== null && this.currentUser.id !== undefined;
    }

    /**
     * checking user permission and allows to route
     * @param:: type
     */
    checkUserBusinessType(type?) {
        if (AppConstants.isNotNullCondition(this.currentUser)) {
            return this.currentUser.permissions === type;
        }
    }

    /**
     *
     */
    ngOnDestroy(): void {
        this.user_subscription.unsubscribe();
    }

}
